import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { InvoiceService } from '../../../../Services/Invoice/invoice.service';

@Component({
  selector: 'app-product-wise-sale',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './product-wise-sale.component.html',
  styleUrl: './product-wise-sale.component.css'
})
export class ProductWiseSaleComponent implements OnInit {
  
  activeTab: 'all' | 'ready' | 'assembly' = 'all';

  // Stats / KPIs (Values made dynamic)
  stats = [
    { label: 'Total Sales Volume', value: '₹ 0', icon: '📈', color: 'bg-orange-100 text-orange-600' },
    { label: 'Total Silver Weight', value: '0g', icon: '⚖️', color: 'bg-yellow-100 text-yellow-600' },
    { label: 'Items in Assembly', value: '0', icon: '⚒️', color: 'bg-blue-100 text-blue-600' },
  ];

  allInvoices: any[] = [];
  readySales: any[] = [];
  assemblyLine: any[] = [];

  constructor(private invoiceService: InvoiceService) {}

  ngOnInit() {
    this.getInvoiceData();
  }

  getInvoiceData() {
    this.invoiceService.getInvoices().subscribe((res: any) => {
      this.allInvoices = Array.isArray(res) ? res : (res.data || []);
      this.processData();
    });
  }

  processData() {
    let totalRevenue = 0;
    let totalWeight = 0;
    const readyArr: any[] = [];
    const assemblyArr: any[] = [];

    this.allInvoices.forEach(inv => {
      inv.items?.forEach((item: any) => {
        const amt = parseFloat(item.stout_final_amount || 0);
        const wt = parseFloat(item.stout_total_wt || 0);
        const type = item.category?.Type; // Master, Product, or Assembly
        const subType = item.category?.SubType;

        totalRevenue += amt;
        totalWeight += wt;

        if (type === 'Master' || type === 'Product') {
          readyArr.push({
            name: item.stout_item_name || item.category?.name,
            type: subType ? (subType.charAt(0).toUpperCase() + subType.slice(1)) : (type === 'Product' ? 'Standard' : 'Ready'),
            purity: item.stout_purity || item.stout_metal_type || 'N/A',
            weight: wt + 'g',
            amount: '₹ ' + amt.toLocaleString()
          });
        } else if (type === 'Assembly') {
          assemblyArr.push({
            process: item.category?.name,
            batch: item.stout_invoice_number || 'N/A',
            input: wt + 'g',
            estVal: amt > 0 ? '₹ ' + amt.toLocaleString() : '--',
            status: item.stout_status || 'Invoiced',
            color: this.getProcessColor(item.category?.name)
          });
        }
      });
    });

    this.readySales = readyArr;
    this.assemblyLine = assemblyArr;

    // Update KPI Card Values
    this.stats[0].value = '₹ ' + totalRevenue.toLocaleString();
    this.stats[1].value = (totalWeight / 1000).toFixed(2) + ' Kg';
    this.stats[2].value = this.assemblyLine.length.toString();
  }

  // Helper to assign consistent colors to processes
  getProcessColor(name: string) {
    const colors: any = { 
        'NAJARIA': 'bg-blue-400', 
        'RINGS': 'bg-orange-400',
        'CHAIN': 'bg-purple-400' 
    };
    return colors[name] || 'bg-green-400';
  }

  get showReady() { return this.activeTab === 'all' || this.activeTab === 'ready'; }
  get showAssembly() { return this.activeTab === 'all' || this.activeTab === 'assembly'; }

  setTab(tab: 'all' | 'ready' | 'assembly') {
    this.activeTab = tab;
  }
}